/**
 * Content item types: external content (docs, Notion, etc.) with stored content and summaries.
 * Referenced by Thread messages and Story items.
 */

import { z } from 'zod';
import { CheckpointSummarySchema } from './checkpoints';

export const ContentSourceSchema = z.enum(['notion', 'doc', 'slack_thread', 'other']);
export type ContentSource = z.infer<typeof ContentSourceSchema>;

export const ContentItemMetaSchema = z.object({
  contentId: z.string(),
  workspaceId: z.string(),
  source: ContentSourceSchema,
  /** Id in the external system (e.g. Notion page id, doc url) */
  externalId: z.string(),
  /** If source is slack_thread, points to Thread DO id */
  threadId: z.string().nullable(),
  title: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ContentItemMeta = z.infer<typeof ContentItemMetaSchema>;

/** Key/path to raw content in object store or DO block storage */
export const ContentStorageRefSchema = z.object({
  storageKey: z.string(),
  /** Optional: mime type or format hint */
  contentType: z.string().optional(),
});
export type ContentStorageRef = z.infer<typeof ContentStorageRefSchema>;

export const ContentCheckpointSummarySchema = CheckpointSummarySchema.extend({
  contentId: z.string(),
});
export type ContentCheckpointSummary = z.infer<typeof ContentCheckpointSummarySchema>;
